/**
 * In this file, we create a React component
 * which incorporates components provided by Material-UI.
 */
import React, { useEffect } from 'react';
import queryString from 'query-string';
import Helmet from 'react-helmet';

import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';

import './style.scss';
import logo from './img/puntacable.svg';
import LoginForm from './LoginForm';

const Login = ({ location, translate }) => {
  useEffect(() => {
    document.title = 'Puntacable';
    document.body.style.backgroundColor = '#5F79F8';
    document.body.className = 'uplay-body';
  });
  const api = new ServiceApi();
  const parameters = queryString.parse(location.search);
  const _validateParams = () => {
    if (!parameters.client_id || !parameters.redirect_uri || !parameters.response_type)
      return false;
    return true;
  }

  return (
    <div className="uplay-container">
      <Helmet>
        <link rel="icon" type="image/png" href="http://www.uplay.com.uy/uplay/static/Resources/favicon.ico" sizes="16x16" />
      </Helmet>
      <header>
        <img className='uplay-logo' src={logo} alt='Uplay' />
      </header>
      {
        _validateParams()
          ? <LoginForm
            api={api}
            location={location}
          />
          : <RequestLoginErrorMessage
            onlyMessage={true}
            message={translate('RequestLoginErrorMessage')}
          />
      }
    </div>
  );
}

export default Login;
